// extracted by mini-css-extract-plugin
module.exports = {"container":"DetallesLigaPago_container__m5zOw","container-loading":"DetallesLigaPago_container-loading__1dxeT","text-loading":"DetallesLigaPago_text-loading__1XfYW"};